import {
  addDays,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  endOfMonth,
  startOfMonth,
  startOfYear,
  endOfYear,
  addMonths,
  addYears
} from "date-fns";

const definedsDates = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  startOfLastSevenDay: startOfDay(addDays(new Date(), -7)),
  startOfLastThirtyDay: startOfDay(addDays(new Date(), -30)),
  startOfLastSixtyDays: startOfDay(addDays(new Date(), -60)),
  startOfLastNintyDay: startOfDay(addDays(new Date(), -90)),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
  startOfLast2Months: startOfMonth(addMonths(new Date(), -2)),
  startOfLast3Months: startOfMonth(addMonths(new Date(), -3)),
  startOfLast6Months: startOfMonth(addMonths(new Date(), -6)),
  startOfYear: startOfYear(new Date()),
  endOfYear: endOfYear(new Date()),
  startOflastYear: startOfYear(addYears(new Date(), -1)),
  endOflastYear: endOfYear(addYears(new Date(), -1))
};

export { definedsDates };
